import { AxiosGlobalFilters } from '../config';

export const PermissionService = {
  // Catálogo de perfis. EmpresaId vai em HEADER (o query param empresaId saiu da API).
  // Não enviar tipoUsuarioAlvo aqui: a tela de acessos edita N usuários de tipos
  // possivelmente diferentes — o back valida compatibilidade por usuário no PUT.
  getPermissions: ({ empresa, unidade }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: 'v1/permissoes',
      headers: {
        'content-type': 'application/json',
        EmpresaId: empresa,
        UnidadeId: unidade,
      },
    });
  },
  // Detalhe de um usuário — usado para preservar filtrosTodosTiposAnomalias no replace
  // (o PUT substitui o conjunto inteiro e não existe GET das permissões atuais).
  getUsuario: ({ usuario, EmpresaId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `v1/usuarios/${usuario}`,
      headers: {
        'content-type': 'application/json',
        EmpresaId,
      },
    });
  },
  // PUT /v1/usuarios/permissoes — substituição INTEGRAL do conjunto de UM usuário por chamada.
  // itens precisa conter a linha base { site: null } (sem ela o back devolve 422) e
  // EmpresaId vai só em HEADER, nunca no body.
  savePermission: ({ usuario, itens, EmpresaId }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: 'v1/usuarios/permissoes',
      data: { usuario, itens },
      headers: {
        'content-type': 'application/json',
        EmpresaId,
      },
    });
  },
};
